import { Component } from '@angular/core';
import { LanguagesSwitcherComponent } from '../../components/languages-switcher/languages-switcher.component';

@Component({
  selector: 'app-settings',
  imports: [LanguagesSwitcherComponent],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent {

}
